<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Custos</h3>
        <d-link class="btn btn-success text-white float-right " :to="{ name: 'admin-cost-new' }">Novo custo</d-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Custos Ativos</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <EntityTable
                :items="costs.list"
                edit-route-name="admin-cost-edit"
                edit-param-key="costId"
                delete-event="DELETE_COST"
                modal-title="Confirme exclusão de custo"
                modal-message="Tem certeza que deseja excluir esse custo?"
                :cancel-delete="close"
                :confirm-delete="deleteRow"
                @select-item-to-delete="handleSelect"
              />
            </div>
            <pagination :total-items="costs.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import EntityTable from '_common/ui/EntityTable.vue';
import EntityDeleteMixin from '_common/mixins/EntityDeleteMixin';
import { _DELETE_COST_ } from '../components/CostModel';

export default {
  name: 'cost-list',
  components: {
    Pagination,
    EntityTable,
  },
  mixins: [EntityDeleteMixin],
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
        slug: 'cost',
      },
      selectedObject: null,
      DELETE_COST: _DELETE_COST_,
      redirectPath: '/admin/custos/lista/1',
      successMessage: 'Custo deletado com sucesso',
      emitEvent: 'update:pagination',
    };
  },
  computed: {
    costs() {
      const { costList } = this.$store.state.cost;
      if (costList && costList.list.length) {
        return costList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getCostList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getCostList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    handleSelect(itemId) {
      this.selectedObject = itemId;
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination');
  },
};
</script>

<style lang="scss" scoped>
</style>
